import BaseClass from "../BaseClass";

export default class Lightbox extends BaseClass {

    constructor(element) {
        super(element);

        this.$container = null;
        this.$lightboxElement = null;
        this.lightboxIsOpen = false;
        this.openLightboxListener = null;
        this.closeLightboxListener = null;
    }

    /**
     * Listener NUR erstellen.
     */
    init() {
        const mySelf = this;

        // lightbox öffnen
        this.openLightboxListener = function (event) {
            mySelf.openLightbox(event);
        };

        // lightbox schließen
        this.closeLightboxListener = function (event) {
            mySelf.closeLightbox(event);
        };
    }

    openLightbox() {
        if (this.lightboxIsOpen) {
            return false;
        }

        let isVideo = false;

        if ($(event.target).is("video")) {
            isVideo = true;
        } else {
            $(event.target).parents().each(function () {
                if ($(this).is("video-js")) {
                    isVideo = true;
                    return;
                }
            });
        }

        if (isVideo) {
            // Keine Lightbox für laufende Videos
            return false;
        }

        this.$container = $('[data-type="lightbox"]');
        this.lightboxIsOpen = true;

        $(document).trigger('video:stop');
        $(document).trigger('show:loading');

        this.$lightboxElement = this.templatesWorker.getTemplate('lightbox-js-template');
        const $lightboxContent = this.loadLightboxContent();
        this.$lightboxElement.find('[data-type="lightboxcontent"]').html($lightboxContent);

        this.$container.empty();
        this.$container.html(this.$lightboxElement);
        this.$container.removeClass('hidden');

        $(document).trigger('content:loaded');

        // lightbox close
        $(document).on('keyup', this.closeLightboxListener);
        this.$lightboxElement.on('click', this.closeLightboxListener);

        $(document).trigger('hide:loading');
    }

    loadLightboxContent() {
        // wird vom child je nach Bedarf angepasst überschrieben
    }

    closeLightbox(event) {
        // nur Esc durchlassen
        if (event.type == "keyup" && event.which != 27) {
            return false;
        }

        // Klick aufs Bild soll nicht zum Schließen führen
        if (event.type == "click") {
            if ($(event.target).is('img')) {
                return false;
            }
        }

        let isVideo = false;

        if ($(event.target).is("video")) {
            isVideo = true;
        } else {
            $(event.target).parents().each(function () {
                if ($(this).is("video-js")) {
                    isVideo = true;
                    return;
                }
            });
        }

        if (isVideo) {
            // Keine Lightbox für laufende Videos
            return false;
        }

        this.lightboxIsOpen = false;

        // listener zum schließen deaktivieren
        $(document).off('keyup', this.closeLightboxListener);
        this.$lightboxElement = null;

        // hide and empty
        this.$container.addClass('hidden').empty();
    }

    destroyListener() {

        this.$element.off('click', this.openLightboxListener);
        this.$element.off('click', this.closeLightboxListener);

        if (this.$lightboxElement != null && this.$lightboxElement.length > 0) {
            this.$lightboxElement.off('click', this.closeLightboxListener);
        }
    }
}